import React from 'react'
import { Heading } from '@myxplor/ui'

const ListEmpty = () => (
  <Heading small className="list--noRecords">
    No Records Found
  </Heading>
)

export default ListEmpty



// WEBPACK FOOTER //
// ./src/ui/list/views/empty.jsx